import React from 'react';
import ReactDOMServer from 'react-dom/server';
import base64 from 'base-64';
import styled, { css } from 'styled-components';
import { breakpoint } from '../../../styling/mixins/breakpoints';
import { getColor } from '../../../styling/mixins/colors';
import ChevronLeft from '../../../../icons/chevron-image-slider-left.svg';
import ChevronRight from '../../../../icons/chevron-image-slider-right.svg';
const svgLeft = ReactDOMServer.renderToString(<ChevronLeft />);
const svgRight = ReactDOMServer.renderToString(<ChevronRight />);
const chevronLeftAsBase64 = base64.encode(svgLeft);
const chevronRightAsBase64 = base64.encode(svgRight);

const MainSwiperMixin = css`
  max-width: 400px;
  max-height: 400px;
  aspect-ratio: 1/1;
  position: unset !important;
  & div.swiper-pagination {
    bottom: 0;
    ${breakpoint('medium')} {
      display: none;
    }
  }
  ${breakpoint('medium')} {
    max-width: 348px;
    max-height: 348px;
  }
  ${breakpoint('large')} {
    max-width: 468px;
    max-height: 468px;
  }
  ${breakpoint('xlarge')} {
    max-width: 660px;
    max-height: 660px;
  }
  ${breakpoint('xxlarge')} {
    max-width: 768px;
    max-height: 768px;
  }
`;

export const StyledSwiper = styled.div`
  position: relative;
  padding-bottom: 3.4rem;
  cursor: pointer;

  ${breakpoint('medium')} {
    padding-bottom: unset;
  }

  .mainSwiper {
    ${MainSwiperMixin}
  }
  .mainSwiper-Placeholder {
    ${MainSwiperMixin}

    margin-left: 5%;
    
    ${breakpoint('small')} {
      margin-left: 25%;
    }
    ${breakpoint('medium')} {
      margin-left: 18px;
    }
    ${breakpoint('large')} {
      margin-left: 55px;
    }
    ${breakpoint('xlarge')} {
      margin-left: 140px;
    }
    ${breakpoint('xxlarge')} {
      margin-left: 118px;
    }
  }
  .image {
    width: 100%;
    height: 100%;
    aspect-ratio: 1/1;
    object-fit: contain;
  }

  .thumbnail-swiper {
    display: none;
    margin-top: 0.8rem;
    max-width: 328px;
    max-height: 328px;
    .swiper-wrapper {
      justify-content: center;
    }
    ${breakpoint('medium')} {
      display: block;
      max-width: 348px;
    }
    ${breakpoint('large')} {
      max-width: 468px;
    }
    ${breakpoint('xlarge')} {
      max-width: 660px;
    }
    ${breakpoint('xxlarge')} {
      max-width: 768px;
    }
  }
  .thumbnail-slide {
    aspect-ratio: 1/1;
    box-sizing: border-box;
    object-fit: contain;
    ${breakpoint('medium')} {
      max-width: 36.5px;
      max-height: 36.5px;
    }
    ${breakpoint('large')} {
      max-width: 51.5px;
      max-height: 51.5px;
    }
    ${breakpoint('xlarge')} {
      max-width: 75.5px;
      max-height: 75.5px;
    }
    ${breakpoint('xxlarge')} {
      max-width: 89px;
      max-height: 89px;
    }
  }
  .thumbnail-image {
    width: 100%;
    height: 100%;
    aspect-ratio: 1/1;
    object-fit: contain;
  }

  .swiper-slide-thumb-active {
    border: 1px solid ${getColor('grey', 900)};
  }

  .swiper-button-prev,
  .swiper-button-next{
    margin-top: -48px;
  }

  .swiper-button-prev {
    background: url(data:image/svg+xml;base64,${chevronLeftAsBase64});
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center;
    width: 5rem;
    left: -16px;
    ${breakpoint('medium')} {
      left: 10px;
    }
  }

  .swiper-button-prev::after {
    display: none;
  }

  .swiper-button-next {
    background: url(data:image/svg+xml;base64,${chevronRightAsBase64});
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center;
    width: 5rem;
    right: -16px;
    ${breakpoint('medium')} {
      right: 10px;
    }
  }

  .swiper-button-next::after {
    display: none;
  }

  .swiper-pagination-bullet {
    background-color: ${getColor('grey', 400)};
    border-radius: 0;
    width: 2.4rem;
    height: 0.6rem;
    opacity: 1;
  }

  .swiper-pagination-bullet-active {
    background-color: ${getColor('grey', 900)};
  }
}
`;
